import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneUserCallTo.styl';

Vue.component('BXmakerAuthuserphoneUserCallTo',
    {
        props: {
            value: {
                type: String,
                default: ''
            }
        },
        computed: {
            localize() {
                return BX.Vue.getFilteredPhrases('BXMAKER_AUTHUSERPHONE_CORE_USER_CALLTO_');
            },
            link(){
                let number = this.value.replace(/[^\d]/g, '');
                if(number.length === 11)
                {
                    number = number.replace(/^8/, '+7')
                }
                return 'tel:+' + number;
            }
        },
        //language=Vue
        template: `
            <div class="bxmaker-authuserphone-usercallto " >
                <div class="bxmaker-authuserphone-usercallto__value" v-if="value">
                    <a :href="link" rel="nofollow">{{value}}</a>
                </div>
                <div class="bxmaker-authuserphone-usercallto__value" v-else>
                    {{localize.BXMAKER_AUTHUSERPHONE_CORE_USER_CALLTO_PLACEHOLDER}} 
                </div>
            </div>
        `,
    });